<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h3><span class="material-icons md-24 text-main-gradient">face</span> Pacientes</h3>
                </div>
                <div class="col-md-12 mt-2 mb-3">
                    <search-talent :main-id="currentUser?.mainId" @notify="notify" @select="handlePacienteSelected" />
                </div>
                <div class="col-md-5 mt-2 mb-4">
                    <h4>{{ pacienteSeleccionado ? 'Paciente Actual' : 'Nuevo Paciente' }}</h4>
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son opcionales.</p>
                            <div class="row">
                                <div class="col-md-12" v-if="nuevoPaciente.subsecuencia">
                                    <p v-if="nuevoPaciente.subsecuencia == 'Primera Vez'">🆕 El paciente te visita por primera vez</p>
                                    <p v-else>🔄 El paciente es subsecuente</p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Nombre completo</label>
                                    <input type="text" class="form-control" v-model="nuevoPaciente.nombre" required>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Género</label>
                                    <select class="form-control" v-model="nuevoPaciente.genero" required>
                                        <option value="Masculino">Masculino</option>
                                        <option value="Femenino">Femenino</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Fecha de nacimiento</label>
                                    <input type="date" class="form-control" v-model="nuevoPaciente.fecha_nacimiento"
                                        required>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Teléfono</label>
                                    <input type="text" v-mask="'###-###-####'" class="form-control"
                                        v-model="nuevoPaciente.telefono">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Email <span class="text-danger">*</span></label>
                                    <input type="email" class="form-control" v-model="nuevoPaciente.email">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Dirección <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="nuevoPaciente.direccion"
                                        maxlength="100">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">¿Tiene Seguridad Social?</label>
                                    <select class="form-control" v-model="nuevoPaciente.tiene_seguridad_social" required>
                                        <option :value="true">Sí</option>
                                        <option :value="false">No</option>
                                    </select>
                                </div>
                                <div class="col-md-6 mb-3" v-if="nuevoPaciente.tiene_seguridad_social">
                                    <label class="form-label">Institución de Salud</label>
                                    <select class="form-control" v-model="nuevoPaciente.institucion_salud" required>
                                        <option value="IMSS">IMSS</option>
                                        <option value="ISSSTE">ISSSTE</option>
                                        <option value="PEMEX">PEMEX</option>
                                        <option value="SEDENA">SEDENA</option>
                                        <option value="SEMAR">SEMAR</option>
                                        <option value="INSABI">INSABI</option>
                                        <option value="IMSS-BIENESTAR">IMSS-BIENESTAR</option>
                                        <option value="PRIVADO">PRIVADO</option>
                                        <option value="OTRO">OTRO</option>
                                        <option value="NINGUNA">NINGUNA</option>
                                    </select>
                                </div>
                                <div class="col-md-12 text-center">

                                    <div v-if="userStats !== 1">                                
                                        <vs-button v-if="isEditing" @click="actualizarPaciente" color="rgb(59,222,200)"
                                            gradient block>
                                            🔄 Actualizar paciente
                                        </vs-button>
                                        <vs-button v-if="isEditing && pacienteSeleccionado?.estatus_cita" @click="iniciarConsulta" color="rgb(0, 102, 153)"
                                            gradient block>
                                            ⚕️ Iniciar atención
                                        </vs-button>
                                        <vs-button v-if="isEditing && !pacienteSeleccionado?.estatus_cita" @click="iniciarConsultaSincita" color="rgb(0, 102, 153)"
                                            gradient block>
                                            ⚕️ Iniciar atención sin cita agendada
                                        </vs-button>
                                     </div>
                                    <div v-else>
                                         <div class="alert alert-warning text-center">
                                            ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                                            Aún puedes buscar a tus pacientes y consultar su historial médico, notas médicas y sus derivados. <br>
                                            <router-link to="/paquetes">Renovar aquí</router-link>
                                        </div>
                                    </div>       



                                    <a class="smallText text-center me-3" v-if="isEditing" @click="cagaHistoriaConsulta" href="#">Historia de consultas</a>
                                    <!-- <a class="smallText text-center me-3" v-if="isEditing" @click="toggleHistoriaConsultas" href="#">Historia de consultas</a> -->
                                    <a class="smallText text-center" v-if="isEditing" @click="toggleGraficoEstudios" href="#">Ver gráfico de estudios</a>
                                    <vs-button v-if="!isEditing && userStats !== 1" @click="crear_paciente" color="rgb(59,222,200)" gradient block>
                                        💾 Guardar paciente
                                    </vs-button>
                                    <hr v-if="isEditing" @click="resetForm" />
                                    <div class="d-flex justify-content-center gap-2">
                                        <a class="smallText text-center" v-if="isEditing" @click="toggleHistoriaClinica"
                                            href="#">Historia Clínica</a>
                                        <!-- <a class="smallText text-center" v-if="isEditing" @click="toggleNotaMedica"
                                            href="#">Nota Médica</a> -->
                                        <a class="smallText text-center" v-if="isEditing" @click.prevent="showConsentimientos"
                                            href="#">Consentimiento Informado</a>
                                        <!-- <a class="smallText text-center" v-if="isEditing" @click="resetForm"
                                            href="#">Valoración Preoperatoria </a> -->
                                    </div>
                                    <a class="smallText text-center" v-if="isEditing" @click="resetForm"
                                        href="#">Limpiar Formulario</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div ref="nuevoDiv"></div>
                  
                </div>



                <div class="col-md-7 mt-2 mb-4">
                    <h4>Citas agendadas/confirmadas para hoy</h4>
                    <div class="table-responsive" v-if="pacientes.length">
                        <vs-table class="custom-table">
                            <template #thead>
                                <vs-tr>
                                    <vs-th class="col-nombre">Nombre</vs-th>
                                    <vs-th class="col-genero">Género</vs-th>
                                    <vs-th class="col-fecha">Fecha</vs-th>
                                    <vs-th class="col-creacion">Estatus cita</vs-th>
                                    <vs-th class="col-acciones">Acciones</vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="paciente.id" v-for="paciente in pacientes" :data="paciente">
                                    <vs-td class="col-nombre">{{ paciente.nombre }}</vs-td>
                                    <vs-td class="col-genero">{{ paciente.genero }}</vs-td>
                                    <vs-td class="col-fecha">{{ formatDate(paciente.fecha_nacimiento) }}</vs-td>
                                    <vs-td class="col-creacion">{{ paciente.estatus_cita }}</vs-td>
                                    <vs-td class="col-acciones">
                                        <vs-button size="small" color="rgb(59,222,200)" gradient block small
                                            @click="seleccionarPaciente(paciente)">
                                            Atender
                                        </vs-button>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <div v-else class="text-center text-muted">
                        <p>No tienes citas agendadas el día de hoy</p>
                    </div>
                    <v-pagination v-model="currentPage" :page-count="totalPages" @input="fetchPacientes" />
                </div>



                <div class="col-md-12 mt-2 mb-4">
                                        <!-- Sección de Nota Médica -->
                    <div class="mt-4" v-if="pacienteSeleccionado && showNotaMedica && !showHistoriaClinica">
                        <h4>Nota Médica</h4>
                        <div class="card mb-3">
                            <div class="card-body">
                                <h5 class="card-title">Datos del Paciente</h5>
                                <p>
                                    <strong>Nombre:</strong> {{ pacienteSeleccionado?.nombre || 'No aplica' }} <br>
                                    <strong>Género:</strong> {{ pacienteSeleccionado?.genero || 'No aplica' }} <br>
                                    <strong>Fecha de Nacimiento:</strong> {{ pacienteSeleccionado?.fecha_nacimiento ? formatDate(pacienteSeleccionado.fecha_nacimiento) : 'No aplica' }} <br>
                                    <strong>Teléfono:</strong> {{ pacienteSeleccionado?.telefono || 'No aplica' }} <br>
                                    <strong>Email:</strong> {{ pacienteSeleccionado?.email || 'No aplica' }} <br>
                                    <strong>Dirección:</strong> {{ pacienteSeleccionado?.direccion || 'No aplica' }} <br>
                                    <strong>Seguridad Social:</strong> {{ pacienteSeleccionado?.tiene_seguridad_social ? 'Sí' : 'No' }} <br>
                                    <strong>Institución de Salud:</strong> {{ pacienteSeleccionado?.institucion_salud || 'No aplica' }}
                                </p>
                            </div>
                        </div>
                        <div class="alert alert-info">
                            <p>
                                <strong class="fw-bold">Nota: Solo se pueden generar y editar notas médicas el mismo día en que se realiza la consulta.</strong><br>
                                ✅ <em>"Las notas médicas deberán elaborarse en el momento en que se otorga la atención médica"</em> (NOM-004-SSA3-2012, apartado 4.7).<br>
                                Esto significa que la nota médica debe registrarse al finalizar la atención y, por normatividad, no debe posponerse para días posteriores.<br><br>

                                <strong class="fw-bold">📌 ¿Hasta cuándo puedo registrar o editar una nota médica?</strong><br>
                                Puedes registrar y finalizar la nota médica hasta el final de tu jornada laboral. A partir de las <strong class="fw-bold">23:00 horas, el sistema bloqueará automáticamente </strong> la edición de la nota médica.<br><br>

                                <strong class="fw-bold">⚠️ ¿Qué pasa si no se registra a tiempo?</strong><br>
                                ❌ Puede considerarse una omisión legal, afectando la defensa del médico ante una queja o proceso legal.<br>
                                ❌ Puede interpretarse como una falta en la calidad de atención durante auditorías o revisiones clínicas.<br>
                                ❌ El médico o la clínica pueden recibir observaciones o sanciones si la documentación no está completa conforme a la normativa vigente.
                            </p>
                        </div>
                       
                        <div v-if="notaMedicaConsultas.length">
                            <div v-for="(consulta, index) in notaMedicaConsultas" :key="index" class="card mb-3">
                                <div class="card-body">
                                    <h5 class="card-title">📅 Fecha de consulta: {{ formatDateTime(consulta.creado_en) || 'No aplica' }}</h5>
                                    <p>
                                        <strong class="fw-bold">Motivo:</strong> {{ consulta.motivo || 'No aplica' }} <br>
                                        <strong class="fw-bold">Tipo Consulta:</strong> {{ consulta.tipo_consulta || 'No aplica' }} <br>
                                        <small v-if="notaMedicaConsultas[index].nota_medica_id != 0 && notaMedicaConsultas[index].estatus_nota != 'finalizada' && notaMedicaConsultas[index].estatus_nota != 'incompleta'">
                                            Esta nota médica no está finalizada, recuerda que al final de tu jornada se finalizará.
                                        </small>
                                        <small v-if="notaMedicaConsultas[index].estatus_nota == 'incompleta'">
                                            <strong>❌ Esta nota no fue completada exitosamente para cumplir con la norma NOM-004-SSA3-2012.</strong> <br>
                                            <strong>La norma es clara en el apartado 4.7: </strong> 
                                            <em> “Las notas médicas deberán elaborarse en el momento en que se otorga la atención médica.”</em> <br>

                                        </small>
                                    </p>
                                    <div class="text-start">
                                        <template v-if="notaMedicaConsultas[index].nota_medica_id != 0 && notaMedicaConsultas[index].estatus_nota == 'finalizada'">
                                            <div class="d-flex align-items-center flex-wrap gap-2">
                                                <vs-button @click="verNotaMedicaMet(notaMedicaConsultas[index].nota_medica_id)" color="rgb(59,222,200)" gradient>
                                                    Ver Nota Médica
                                                </vs-button>
                                                <a class="ms-2 smallText" @click="openRecetas(notaMedicaConsultas[index])" href="#">Crear/ver receta</a>
                                                <a class="ms-2 smallText" @click="openArchivos(notaMedicaConsultas[index])" href="#">Agregar/ver fotos o archivos</a>
                                                <a class="ms-2 smallText" @click="openAdicionales(notaMedicaConsultas[index])" href="#">Agregar/ver datos adicionales a la nota</a>
                                                <a class="ms-2 smallText" @click="openEstudios(notaMedicaConsultas[index])" href="#">Cargar/ver estudios solicitados</a>
                                            </div>
                                        </template>
                                        <template v-else-if="notaMedicaConsultas[index].estatus_nota == 'incompleta'">
                                            <vs-button @click="verNotaMedicaMet(notaMedicaConsultas[index].nota_medica_id)" color="rgb(59,222,200)" gradient>
                                                Ver Nota Médica
                                            </vs-button>
                                        </template>
                                        <template v-else>
                                            <a class="smallText" v-if="userStats !==1" @click="openNotaMedica(notaMedicaConsultas[index])" href="#">Nota médica</a>
                                            <a class="ms-2 smallText" @click="openRecetas(notaMedicaConsultas[index])" href="#">Crear/ver receta</a>
                                            <a class="ms-2 smallText" @click="openArchivos(notaMedicaConsultas[index])" href="#">Agregar/ver fotos o archivos</a>
                                            <a class="ms-2 smallText" @click="openAdicionales(notaMedicaConsultas[index])" href="#">Agregar/ver datos adicionales a la nota</a>
                                            <a class="ms-2 smallText" @click="openEstudios(notaMedicaConsultas[index])" href="#">Cargar/ver estudios solicitados</a>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="text-muted">No hay consultas recientes para generar una nota médica.</p>
                        </div>
                    </div>

                    
                </div>


                <div class="col-md-12 mt-2 mb-4"  v-if="showHistoriaClinica && !showNotaMedica">

                    <Historia_clinica 
                        :currentUser="currentUser" 
                        :paciente="pacienteSeleccionado"  />

                </div>


            </div>
        </div>



        <!-- Modal para ver historia clínica completa -->
        <vs-dialog prevent-close v-model="showHistoriaClinicaCompleta" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    <span class="material-icons md-48 text-main-gradient">face</span> <br> Historia Clínica
                </h4>
            </template>
            <div class="container">
                <div class="row mb-3">
                    <div class="col-md-8">
                        <p>
                            <strong class="fw-bold">Nombre:</strong> {{ pacienteSeleccionado?.nombre || 'No aplica' }} |
                            <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ pacienteSeleccionado?.fecha_nacimiento ? formatDate(pacienteSeleccionado.fecha_nacimiento) : 'No aplica' }} |
                            <strong class="fw-bold">Género:</strong> {{ pacienteSeleccionado?.genero || 'No aplica' }}  <br>
                            <strong class="fw-bold">Teléfono:</strong> {{ pacienteSeleccionado?.telefono || 'No aplica' }} |
                            <strong class="fw-bold">Email:</strong> {{ pacienteSeleccionado?.email || 'No aplica' }} |
                            <strong class="fw-bold">Dirección:</strong> {{ pacienteSeleccionado?.direccion || 'No aplica' }}
                        </p>
                    </div>
                    <div class="col-md-4 text-end">
                        🖨️<a class="text-center" v-if="isEditing" @click="printHistoriaClinica(historiaClinicaCompleta)"
                        href="#">Imprimir historia</a>
                    </div>
                </div>
                <div v-if="historiaClinicaCompleta.length">
                    <div v-for="(registro, index) in historiaClinicaCompleta" :key="index" class="card mb-3">
                        <div class="card-body">
                            <h5 class="card-title">📅 Fecha de creación {{ formatDate(registro.creado_en) || 'No aplica' }}</h5>
                            <p>
                                <strong class="fw-bold">Tipo:</strong> {{ registro.tipo || 'No aplica' }} |
                                <strong class="fw-bold">Enfermedad:</strong> {{ registro.enfermedad || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Diagnóstico:</strong> {{ registro.fecha_diagnostico ? formatDate(registro.fecha_diagnostico) : 'No aplica' }} |
                                <strong class="fw-bold">Tratamiento Actual:</strong> {{ registro.tratamiento_actual !== undefined ? (registro.tratamiento_actual ? 'Sí' : 'No') : 'No aplica' }} |
                                <strong class="fw-bold">Severidad:</strong> {{ registro.severidad || 'No aplica' }}
                            </p>
                            <p><strong class="fw-bold">Descripción:</strong> <br> 
                                {{ registro.descripcion || 'No aplica' }}
                            </p>
                            <p><strong class="fw-bold">Observaciones:</strong> <br>
                                 {{ registro.observaciones || 'No aplica' }}
                            </p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="text-muted">No hay registros de historia clínica para este paciente.</p>
                </div>
            </div>
        </vs-dialog>

        <!-- Modal para iniciar consulta -->
        <vs-dialog prevent-close v-model="showConsultaDialog" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    🩺 Nueva Consulta
                </h4>
            </template>
            <Consulta :currentUser="currentUser" :paciente="pacienteSeleccionado" @terminaConsulta="handleConsultaTerminada" />
        </vs-dialog>

        <!-- Modal para iniciar consulta sin cita -->
        <vs-dialog prevent-close v-model="showConsultaDialogSinCita" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    🩺 Nueva Consulta
                </h4>
            </template>
            <ConsultaSinCita 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                @terminaConsultaSinCita="handleConsultaTerminadaSinCita" 
            />
        </vs-dialog>
   
        <!-- Modal para mostrar estudios -->
        <vs-dialog prevent-close v-model="showPacienteEstudiosDialog" class="full-width-dialog">
            <PacienteEstudiosRealizados 
                v-if="pacienteSeleccionado" 
                :paciente_id="pacienteSeleccionado.paciente_id || pacienteSeleccionado.id" 
            />
        </vs-dialog>

        <!-- Modal para ver historia de consultas -->
        <vs-dialog prevent-close v-model="showHistoriaConsultasDialog" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    📋 Historia de Consultas
                </h4>
            </template>
            <div class="container">
                <div class="row mb-3">
                    <div class="col-md-8">
                        <p>
                            <strong class="fw-bold">Nombre:</strong> {{ pacienteSeleccionado?.nombre || 'No aplica' }} |
                            <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ pacienteSeleccionado?.fecha_nacimiento ? formatDate(pacienteSeleccionado.fecha_nacimiento) : 'No aplica' }} |
                            <strong class="fw-bold">Edad:</strong> {{ pacienteSeleccionado?.fecha_nacimiento ? calculateAge(pacienteSeleccionado.fecha_nacimiento) : 'No aplica' }} |
                            <strong class="fw-bold">Género:</strong> {{ pacienteSeleccionado?.genero || 'No aplica' }}  <br>
                            <strong class="fw-bold">Teléfono:</strong> {{ pacienteSeleccionado?.telefono || 'No aplica' }} |
                            <strong class="fw-bold">Email:</strong> {{ pacienteSeleccionado?.email || 'No aplica' }} |
                            <strong class="fw-bold">Dirección:</strong> {{ pacienteSeleccionado?.direccion || 'No aplica' }} <br>
                            <strong class="fw-bold">Tiene Seguridad Social:</strong> {{ pacienteSeleccionado?.tiene_seguridad_social ? 'Sí' : 'No' }} |
                                <strong class="fw-bold">Institución de Salud:</strong> {{ pacienteSeleccionado?.institucion_salud || 'No aplica' }}
                            
                        </p>
                    </div>          
                </div>
                <div v-if="historiaConsultas.length">
                    <div v-for="(consulta, index) in historiaConsultas" :key="index" class="card mb-3">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5 class="card-title">📅 Fecha de consulta: {{ formatDateTime(consulta.creado_en) || 'No aplica' }}</h5>
                                <div class="d-flex justify-content-between align-items-center">
                                    <template v-if="consulta.nota_medica_id != 0">
                                        <vs-button @click="verNotaMedicaMet(consulta.nota_medica_id)" color="rgb(59,222,200)" gradient>
                                            Ver Nota Médica
                                        </vs-button>
                                    </template>
                                    <div class="text-end smallText">
                                        🖨️<a class="text-center" v-if="historiaConsultas.length" @click="printHistoriaConsultas(historiaConsultas[index])" href="#">Imprimir Receta</a>
                                    </div>
                                </div>
                            </div>

                            <p>
                                <strong class="fw-bold">Motivo:</strong> {{ consulta.motivo || 'No aplica' }} <br>
                                <strong class="fw-bold">Tipo de consulta:</strong> {{ consulta.tipo_consulta || 'No aplica' }} <br>
                                <strong class="fw-bold">Diagnóstico:</strong> {{ consulta.diagnostico || 'No aplica' }} <br>
                                <strong class="fw-bold">Pronóstico:</strong> {{ consulta.pronostico || 'No aplica' }} <br>
                                <strong class="fw-bold">Plan de Tratamiento:</strong> {{ consulta.plan_tratamiento || 'No aplica' }}
                            </p>
                            <div class="row">
                                <div class="col-md-4">
                                    <p class="fw-bold mt-3">Signos Vitales:</p>
                                    <ul class="list-group small">
                                        <li class="list-group-item" v-for="(signo, i) in consulta.signos_vitales" :key="i">
                                            ✅ Presión Arterial: {{ signo.presion_arterial || 'No aplica' }} <br>
                                            ✅ Temperatura: {{ signo.temperatura || 'No aplica' }} °C <br>
                                            ✅ Frecuencia Cardíaca: {{ signo.frecuencia_cardiaca || 'No aplica' }} bpm <br>
                                            ✅ Frecuencia Respiratoria: {{ signo.frecuencia_respiratoria || 'No aplica' }} rpm <br>
                                            ✅ Peso: {{ signo.peso || 'No aplica' }} kg <br>
                                            ✅ Estatura: {{ signo.estatura || 'No aplica' }} m <br>
                                            ✅ IMC: {{ signo.imc || 'No aplica' }} <br>
                                            ✅ Saturación de Oxígeno: {{ signo.saturacion_oxigeno || 'No aplica' }}% <br>
                                            ✅ Glucosa: {{ signo.glucosa || 'No aplica' }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-8">
                                    <p class="fw-bold mt-3" v-if="consulta.tratamientos && consulta.tratamientos.length">Medicamentos:</p>
                                    <ul class="list-group small" v-if="consulta.tratamientos && consulta.tratamientos.length">
                                        <li class="list-group-item" v-for="(tratamiento, i) in consulta.tratamientos" :key="i">
                                            💊 Medicamento: {{ tratamiento.medicamento || 'No aplica' }} <br>
                                            💊 Dosis: {{ tratamiento.dosis || 'No aplica' }} <br>
                                            💊 Frecuencia: {{ tratamiento.frecuencia || 'No aplica' }} <br>
                                            💊 Duración: {{ tratamiento.duracion || 'No aplica' }} <br>
                                            💊 Observaciones: {{ tratamiento.observaciones || 'No aplica' }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <fileUploader 
                                        :currentUser="currentUser" 
                                        :paciente="pacienteSeleccionado" 
                                        :consulta_id="historiaConsultas[index].id"
                                        @uploadSuccess="notify('success', 'Archivo subido exitosamente')" 
                                        @uploadError="notify('error', 'Error al subir el archivo')" 
                                    />
                                </div>
                                <div class="col-md-12">
                                    <AgregarEstudios 
                                        :mainId="currentUser.mainId" 
                                        :paciente="pacienteSeleccionado" 
                                        :consulta_id="historiaConsultas[index].id"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="text-muted">No hay registros de consultas para este paciente.</p>
                </div>
            </div>
        </vs-dialog>

        <!-- Modal para Nota Médica -->
        <vs-dialog prevent-close v-model="showNotaMedicaDialog" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    🩺 Generar Nota Médica
                </h4>
            </template>
            <NotaMedica 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                :notaMedicaConsultas="consultaSeleccionada" 
                @terminaNotaMedica="closeNotaMedica" 
            />
        </vs-dialog>
       
       <!-- Modal de vizualiación de nota médica -->
        <vs-dialog prevent-close v-model="showNotaVerMedicaDialog" class="full-width-dialog">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    🩺 Nota Médica
                </h4>
            </template>
            <VerNotaMedica 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                :nota_medica_id="nota_medica_id" 
            />
        </vs-dialog>


        <!-- Modal de vizualiación de nota médica -->
        <vs-dialog prevent-close v-model="showReceta" class="full-width-dialog">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="not-margin mt-3 text-center">
                        💊🧪 Recetas y solicitudes de estudios
                    </h4>
                </div>
            </template>
            <Recetas 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                :notaMedicaConsultas="consultaSeleccionada" 
            />
        </vs-dialog>


        <!-- Modal de vizualiación de archivos -->
        <vs-dialog prevent-close v-model="showArchivosModal" class="full-width-dialog">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="not-margin mt-3 text-center">
                        📷 Imagenes y archivos complentarios
                    </h4>
                </div>
            </template>
            <fileUploader 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                :consulta_id="consultaSeleccionada?.id"
                @uploadSuccess="notify('success', 'Archivo subido exitosamente')" 
                @uploadError="notify('error', 'Error al subir el archivo')" 
            />
        </vs-dialog>
      
        <!-- Modal de vizualiación de archivos -->
        <vs-dialog prevent-close v-model="showAdicionalesModal" class="full-width-dialog">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="not-margin mt-3 text-center">
                        📋 Datos adicionales a la nota médica
                    </h4>
                </div>
            </template>
            <adicionalesNotaMedica 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
                :nota_medica_id="consultaSeleccionada?.nota_medica_id"
            />
        </vs-dialog>

        <!-- Modal de vizualiación de estudios -->
        <vs-dialog prevent-close v-model="showEstudiosModal" class="full-width-dialog">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="not-margin mt-3 text-center">
                        🧪 Estudios complentarios
                    </h4>
                </div>
            </template>
            <AgregarEstudios 
                :mainId="currentUser.mainId" 
                :paciente="pacienteSeleccionado" 
                :consulta_id="consultaSeleccionada?.id"
            />
        </vs-dialog>

        <!-- Modal de vizualiación de consentimientos -->
        <vs-dialog prevent-close v-model="showConsentimientosModal" class="full-width-dialog">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="not-margin mt-3 text-center">
                        📝 Consentimientos
                    </h4>
                </div>
            </template>
            <div class="container">
                <div class="row">
                    <div class="col-md-12" v-if="userStats !== 1">
                        <h5>Consentimiento Informado</h5>
                        <p>
                            Documento obligatorio para autorizar procedimientos, tratamientos o atención médica. Este consentimiento es clínico y debe estar firmado por el paciente, el médico y  testigos, conforme a la NOM-004-SSA3-2012. <br>
                            <a class="smallText text-center" v-if="isEditing" @click.prevent="printConsentimiento('normal')"
                            href="#">🖨️ Imprimir</a>
                        </p>
                        <br>
                        <h5>Consentimiento Informado para tratamiento de datos personales
                        </h5>
                        <p>
                            Documento legal que permite al médico recopilar y resguardar datos personales y de salud del paciente en su expediente clínico digital, cumpliendo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.<br>
                            <a class="smallText text-center" v-if="isEditing" @click.prevent="printConsentimiento('datos')"
                            href="#">🖨️ Imprimir</a>
                        </p>
                    </div>
                    <div class="col-md-12" v-else>
                        <div class="alert alert-warning text-center">
                            ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                            <router-link to="/paquetes">Renovar aquí</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <AgregarConsentimientos 
                :currentUser="currentUser" 
                :paciente="pacienteSeleccionado" 
            />
        </vs-dialog>


    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import axios from 'axios';
    import Multiselect from 'vue-multiselect';
    import SearchTalent from './SearchTalent.vue';
    import vPagination from 'vue-plain-pagination';
    import Consulta from './Consulta.vue';
    import ConsultaSinCita from './ConsultaSinCita.vue';
    import NotaMedica from './NotaMedica.vue';
    import VerNotaMedica from './VerNotaMedica.vue';
    import fileUploader from './fileUploader.vue';
    import AgregarEstudios from './AgregarEstudios.vue';
    import AgregarConsentimientos from './AgregarConsentimientos.vue';
    import PacienteEstudiosRealizados from './PacienteEstudios.vue';
    import adicionalesNotaMedica from './adicionalesNotaMedica.vue';
    import Recetas from './Recetas.vue';
    import Historia_clinica from './Historia_clinica.vue';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Pacientes",
        components: {
            SearchTalent, Multiselect, vPagination, Consulta, NotaMedica, VerNotaMedica, fileUploader, AgregarEstudios, PacienteEstudiosRealizados, ConsultaSinCita, Recetas, Historia_clinica, adicionalesNotaMedica,AgregarConsentimientos
        },

        mounted() {
            console.log('Component mounted');
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    console.log('User loaded from localStorage:', user);
                    // Puedes asignar el usuario a una variable en data si es necesario
                    this.currentUser = user;
                    this.fetchPacientes();
                    setTimeout(() => {
                        this.userStats = this.getUserStatus();
                    }, 500);
                }
            } catch (error) {
                console.error('Error loading user from localStorage:', error);
            }
        },
        data() {
            return {
                userStats: null,
                currentUser: null,
                showReceta: false,
                nota_medica_id: null,
                nuevoPaciente: {
                    nombre: '',
                    genero: 'Masculino',
                    fecha_nacimiento: '',
                    telefono: '',
                    email: '',
                    direccion: '',
                    tiene_seguridad_social: false,
                    institucion_salud: 'NINGUNA'
                },
                pacientes: [], // Lista de pacientes
                currentPage: 1, // Página actual
                totalPages: 1, // Total de páginas
                isEditing: false,
                previewImage: '',
                recoveryLink: null,
                pacienteSeleccionado: null, // Paciente seleccionado
                showHistoriaClinica: false, // Controla la visibilidad del formulario
                historiaClinica: {
                    tipo: 'Heredo-Familiares',
                    enfermedad: '',
                    fecha_diagnostico: '',
                    tratamiento_actual: false,
                    severidad: 'No',
                    descripcion: '',
                    observaciones: ''
                },
                showHistoriaClinicaCompleta: false,
                historiaClinicaCompleta: [],
                showConsultaDialog: false, // Controla la visibilidad del diálogo de consulta
                showConsultaDialogSinCita: false, // Controla la visibilidad del diálogo de consulta sin cita
                showHistoriaConsultasDialog: false,
                showPacienteEstudiosDialog: false,
                historiaConsultas: [],
                showNotaMedica: false, // Controla la visibilidad de la sección de Nota Médica
                notaMedicaConsultas: [],
                showNotaMedicaDialog: false, // Controla la visibilidad del modal de Nota Médica
                showNotaVerMedicaDialog: false, // Controla la visibilidad del modal de Nota Médica
                consultaSeleccionada: null,
                consultaIdActual:null,
                showArchivosModal:false,
                showEstudiosModal:false,
                showAdicionalesModal:false,
                showConsentimientosModal:false,
            };
        },
        methods: {

            showConsentimientos() {
                this.showConsentimientosModal = true;
            },
          
            async printConsentimiento(ruta) {
                // console.log("Imprimiendo historia clínica...", this.paciente, this.historiaClinica);
                const combinedData = {
                    paciente: this.pacienteSeleccionado,
                    displayName: this.currentUser?.displayName || 'No disponible',
                };

                const rutaFinal = ruta === 'normal' ? 'imprimir-consentimiento' : 'imprimir-consentimiento-datos-personales';

                console.log("Datos combinados para imprimir:", combinedData);

                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/${rutaFinal}`, combinedData);

                    if (response.data.status === 'success') {
                        this.closeLoading();

                        await this.callAudit(
                            this.currentUser.mainId,
                            "IMPRESION",
                            "consentimientos",
                            this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id,
                            "Impresión de consentimiento tipo " + ruta
                        );

                        const pdfUrl = `${API}${response.data.pdfUrl}`;

                        // Verificar si es un dispositivo móvil
                        if (this.isMobileDevice()) {
                            // En móvil, abrir en una nueva pestaña
                            window.open(pdfUrl, '_blank');
                            this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                        } else {
                            // En escritorio, mostrar en modal con iframe (código original)
                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        }
                    } else {
                        this.closeLoading();
                        // Usar notify en lugar de $emit si notify está disponible globalmente o via mixin
                        this.notify('error', 'Error al generar el consentimiento informado.');
                    }
                } catch (error) {
                    this.closeLoading();
                    console.error(error);
                     // Usar notify en lugar de $emit
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            openRecetas(nota){
                this.consultaSeleccionada = nota;
                if (!this.consultaSeleccionada?.nota_medica_id) {
                    this.notify('error', 'Debe crear primero la nota médica antes de generar recetas.');
                    return;
                }
                this.showReceta= true;
            },
            openArchivos (nota){
                this.consultaSeleccionada = nota;
                if (!this.consultaSeleccionada?.nota_medica_id) {
                    this.notify('error', 'Debe crear primero la nota médica antes de agregar archivos.');
                    return;
                }
                this.showArchivosModal= true;
            },
            openAdicionales (nota) {
                this.consultaSeleccionada = nota;
                if (!this.consultaSeleccionada?.nota_medica_id) {
                    this.notify('error', 'Debe crear primero la nota médica antes de agregar datos adicionales.');
                    return;
                }
                this.showAdicionalesModal = true;
            },
            openEstudios (nota){
                this.consultaSeleccionada = nota;
                if (!this.consultaSeleccionada?.nota_medica_id) {
                    this.notify('error', 'Debe crear primero la nota médica antes de agregar estudios.');
                    return;
                }
                this.showEstudiosModal = true;
            },
            calculateAge(dateOfBirth) {
                if (!dateOfBirth) return 'No calculado';
                const birthDate = new Date(dateOfBirth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return `${age} años`;
            },
            resetForm() {
                this.nuevoPaciente = {
                    nombre: '',
                    genero: 'Masculino',
                    fecha_nacimiento: '',
                    telefono: '',
                    email: '',
                    direccion: '',
                    tiene_seguridad_social: false,
                    institucion_salud: 'NINGUNA'
                };
                this.isEditing = false;
                this.pacienteSeleccionado = null;
                this.showHistoriaClinica = false;
            },
            async crear_paciente() {
                // Validaciones
                if (!this.vEmpty(this.nuevoPaciente.nombre.trim(), 'Nombre')) return;
                if (!this.vEmpty(this.nuevoPaciente.fecha_nacimiento.trim(), 'Fecha de nacimiento')) return;
                if (this.nuevoPaciente.email && !this.vEmail(this.nuevoPaciente.email.trim())) {
                    this.notify('error', 'Error: Email inválido');
                    return;
                }
                if (!this.vEmpty(this.nuevoPaciente.telefono.trim(), 'Teléfono')) return;
                if (!this.nuevoPaciente.email) {
                    this.nuevoPaciente.email = '';
                }
                if (!this.nuevoPaciente.direccion) {
                    this.nuevoPaciente.direccion = '';
                }
                if (this.nuevoPaciente.institucion_salud === 'NINGUNA' && this.nuevoPaciente.tiene_seguridad_social) {
                    this.nuevoPaciente.tiene_seguridad_social = false;
                }
                if (!this.nuevoPaciente.tiene_seguridad_social) {
                    this.nuevoPaciente.institucion_salud = 'NINGUNA';
                }

                try {
                    this.openLoading();
                    if (this.currentUser && this.currentUser.mainId) {
                        this.nuevoPaciente.personal_medico_id = this.currentUser.mainId;
                    } else {
                        this.notify('error', 'Error: Usuario no autenticado');
                        return;
                    }
                    const response = await axios.post(`${API}/crear_paciente`, this.nuevoPaciente);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Paciente creado exitosamente');
                        this.resetForm();
                        // Recargar la lista de pacientes
                        await this.fetchPacientes();
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
            async actualizarPaciente() {
                if (!this.pacienteSeleccionado) return;


                // Validaciones
                if (!this.vEmpty(this.nuevoPaciente.nombre, 'Nombre')) return;
                if (!this.vEmpty(this.nuevoPaciente.fecha_nacimiento, 'Fecha de nacimiento')) return;

                if (this.nuevoPaciente.email !== '') {
                    if(this.nuevoPaciente.email) {
                        if (!this.vEmail(this.nuevoPaciente.email.trim())) {
                            this.notify('error', 'Email inválido');
                            return;
                        }
                    }else{
                        this.nuevoPaciente.email = '';
                    }
                }

                if (this.nuevoPaciente.telefono !== '') {
                    console.log('Validando teléfono:', this.nuevoPaciente.telefono);
                    if(this.nuevoPaciente.telefono) {
                        if (!/^\d{3}-\d{3}-\d{4}$/.test(this.nuevoPaciente.telefono.trim())) {
                            this.notify('error', 'Teléfono inválido. Debe tener el formato ###-###-####');
                            return;
                        }
                    }else{
                        this.nuevoPaciente.telefono = '';
                    }
                }

                if (!this.nuevoPaciente.tiene_seguridad_social) {
                    this.nuevoPaciente.institucion_salud = 'NINGUNA';
                }

                try {
                    this.openLoading();
                    const pacienteId = this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id;
                    const response = await axios.put(`${API}/actualizar_paciente/${pacienteId}`, this.nuevoPaciente);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Paciente actualizado exitosamente');

                        this.resetForm();
                        this.isEditing = false;
                        this.pacienteSeleccionado = null;
                        await this.fetchPacientes(); // Recargar la lista de pacientes
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
            async fetchPacientes(page = 1) {
                this.pacietes=[]; // Limpiar la lista de pacientes antes de cargar nuevos datos
                try {
                    // const response = await axios.get(`${API}/obtener_pacientes`, {
                    const response = await axios.get(`${API}/listar-consultas-hoy-atencion`, {
                        params: {
                            page,
                            personal_medico_id: this.currentUser?.mainId // Enviar el mainId del usuario actual
                        }
                    });

                    if (response.data.status === 'success') {
                        console.log('Pacientes:', response.data.data);
                        this.pacientes = response.data.data; // Asignar pacientes
                        this.currentPage = response.data.currentPage; // Página actual
                        this.totalPages = response.data.totalPages; // Total de páginas
                    } else {
                        this.notify('error', 'Error al obtener los pacientes');
                    }
                } catch (error) {
                    console.error('Error al obtener los pacientes:', error);
                    this.notify('error', `Error: ${error.message}`);
                }
            },
            async seleccionarPaciente(paciente) {
                console.log('Paciente seleccionado:', paciente);
                this.pacienteSeleccionado = null;
                this.nuevoPaciente = null;
                const tieneCitas = await this.verificarCita(paciente.id);
                const subsecuencia = await this.verificarSubsecuencia(paciente.id);
                this.showNotaMedica =false;

                this.pacienteSeleccionado = tieneCitas.datosPaciente ? { ...tieneCitas.datosPaciente, subsecuencia, tieneCitas } : { ...paciente, subsecuencia, tieneCitas };



                console.log('Paciente seleccionado nuevo:', this.pacienteSeleccionado);
                this.isEditing = true;
                this.resetHistoriaClinica();
                this.showHistoriaClinica = false;
                this.nuevoPaciente = {
                    ...paciente,
                    fecha_nacimiento: paciente.fecha_nacimiento ? paciente.fecha_nacimiento.split('T')[0] : '',
                    subsecuencia: subsecuencia,
                    tiene_seguridad_social: paciente.tiene_seguridad_social === 1,
                    institucion_salud: paciente.institucion_salud || 'NINGUNA'
                }; // Cargar datos del paciente seleccionado, ajustando el formato de la fecha
            },
            async verificarCita(id) {
                console.log('Verificando subsecuencia para el paciente con ID:', id);
                try {
                    const response = await axios.get(`${API}/verificar_citas_paciente`, {
                        params: { id_paciente: id }
                    });

                    console.log('response:', response.data);    
                    if (response.data.status === 'success') {
                        console.log('Citas Activas:', response.data.tieneCitasActivasHoy);
                        return response.data.tieneCitasActivasHoy;
                    } else {
                        // this.notify('error', 'El paciente no cuenta con citas activas.');
                        return null;
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                    return null;
                }
            },
            async verificarSubsecuencia(id) {
                console.log('Verificando subsecuencia para el paciente con ID:', id);
                try {
                    const response = await axios.get(`${API}/paciente_subsecuencia`, {
                        params: { id_paciente: id }
                    });

                    if (response.data.status === 'success') {
                        console.log('Subsecuencia:', response.data.subsecuencia);
                        return response.data.subsecuencia;
                    } else {
                        this.notify('error', 'Error al verificar la subsecuencia del paciente.');
                        return null;
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                    return null;
                }
            },
            async handlePacienteSelected(paciente) {
                this.seleccionarPaciente(paciente);
                this.showNotaMedica=false;
            },


            async sendRecoveryPassword(email) {
                this.recoveryLink = null;
                try {
                    const response = await axios.post(`${API}/admin-sendRecoveryPassword`, {
                        params: { email }
                    });

                    if (response.data.status === 'success') {
                        console.log(response.data.link);
                        this.recoveryLink = response.data.link;
                        this.notify('success', 'Password reset link sent successfully');
                    } else {
                        this.notify('error', response.data.message);
                    }
                } catch (error) {
                    console.error('Error sending password reset email:', error);
                    this.notify('error', `Error: ${error.message}`);
                }
            },
            toggleHistoriaClinica() {
                this.showHistoriaClinica = !this.showHistoriaClinica;
                if (this.showHistoriaClinica) {
                    this.showNotaMedica = false; // Ocultar Nota Médica
                }

                 setTimeout(() => {
                        const el = this.$refs.nuevoDiv;
                        if (el && el.scrollIntoView) {
                            el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                            });
                        } else {
                            console.warn('No se encontró el ref nuevoDiv');
                        }
                        }, 333);
            },
            async guardarHistoriaClinica() {
                this.historiaClinica.descripcion =this.historiaClinica.descripcion.trim();
                this.historiaClinica.observaciones =this.historiaClinica.observaciones.trim();
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para agregar la historia clínica.');
                    return;
                }

                // Validaciones
                if (!this.historiaClinica.tipo.trim()) {
                    this.notify('error', 'El campo "Tipo" es obligatorio.');
                    return;
                }
                if (!this.historiaClinica.tratamiento_actual) {
                    this.notify('error', 'El campo "Tratamiento Actual" es obligatorio.');
                    return;
                }
                if (!this.historiaClinica.severidad.trim()) {
                    this.notify('error', 'El campo "Severidad" es obligatorio.');
                    return;
                }
                if (!this.historiaClinica.descripcion.trim()) {
                    this.notify('error', 'El campo "Descripción" es obligatorio.');
                    return;
                }
                if (!this.historiaClinica.observaciones.trim()) {
                    this.notify('error', 'El campo "Observaciones" es obligatorio.');
                    return;
                }

                try {
                    this.openLoading();
                    const payload = {
                        ...this.historiaClinica,
                        paciente_id: this.pacienteSeleccionado.paciente_id
                    };
                    const response = await axios.post(`${API}/agregar_historia_clinica`, payload);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Historia clínica guardada exitosamente.');
                        this.resetHistoriaClinica();
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
            resetHistoriaClinica() {
                this.historiaClinica = {
                    tipo: '',
                    enfermedad: '',
                    fecha_diagnostico: '',
                    tratamiento_actual: false,
                    severidad: '',
                    descripcion: '',
                    observaciones: ''
                };
            },

            iniciarConsulta() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para iniciar una consulta.');
                    return;
                }
                // this.showConsultaDialog = true;
                this.toggleNotaMedica();
            },
            async cagaHistoriaConsulta() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para iniciar una consulta.');
                    return;
                }

                this.showHistoriaClinica= false;

                try {
                    const response = await axios.get(`${API}/carga_historico_consulta`, {
                        params: { id_paciente: this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id }
                    });

                    if (response.data.status === 'success') {
                        if (response.data.consultaEnCursoHoy.tieneConsultaEnCurso) {
                            await this.toggleNotaMedicaHistorico();
                        } else {
                            // this.showConsultaDialogSinCita = true;
                            this.notify('info', 'El paciente aún no tiene historia de notas médicas.');
                        }
                    } else {
                        this.notify('error', 'Error al verificar la consulta en curso.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }

            },
            async iniciarConsultaSincita() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para iniciar una consulta.');
                    return;
                }

                try {
                    const response = await axios.get(`${API}/verificar_consulta_en_curso`, {
                        params: { id_paciente: this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id }
                    });

                    console.log('Verificando consulta en curso:', response.data);
                    if (response.data.status === 'success') {
                        if (response.data.consultaEnCursoHoy.tieneConsultaEnCurso) {
                            this.notify('info', 'El paciente ya tiene una consulta activa en curso.');
                            this.toggleNotaMedica();
                        } else {
                            this.showConsultaDialogSinCita = true;
                        }
                    } else {
                        this.notify('error', 'Error al verificar la consulta en curso.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }

            },
            handleConsultaTerminada() {
                this.showConsultaDialog = false;
            },
            handleConsultaTerminadaSinCita(response) {
                this.showConsultaDialogSinCita = false;
                console.log('Consulta terminada sin cita, ID:', response);
                this.toggleNotaMedica();
                // Puedes realizar acciones adicionales aquí con response.consultaId
            },
            async toggleGraficoEstudios() {

                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para ver su historia de consultas.');
                    return;
                }

                this.showPacienteEstudiosDialog = true;
            },
            async toggleHistoriaConsultas() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para ver su historia de consultas.');
                    return;
                }

                try {
                    this.openLoading();
                    const response = await axios.get(`${API}/historia_consultas/${this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id}`);
                    if (response.data.status === 'success') {
                        this.historiaConsultas = response.data.data;
                        this.showHistoriaConsultasDialog = true;
                        console.log(this.historiaConsultas);
                    } else {
                        this.notify('error', 'Error al obtener la historia de consultas.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
            async printHistoriaConsultas(consulta) {
                console.log('currentUser:', this.currentUser);
                consulta.displayName = this.currentUser?.displayName || 'No especificado';
                consulta.datosPaciente = this.pacienteSeleccionado;
                console.log('Imprimiendo historia de consulta:', consulta);
                this.openLoading();
                    try {
                        const response = await axios.post(`${API}/imprimir-receta`, consulta);
                        if (response.data.status === 'success') {
                            this.closeLoading();
                            console.log('Receta médica generada:', response.data);
                            const pdfUrl = `${API}${response.data.pdfUrl}`;
                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        } else {
                            this.closeLoading();
                            this.notify('error', 'Error al generar la receta médica.');
                        }
                    } catch (error) {
                        this.closeLoading();
                        this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
         
                    } 
            },
            async printHistoriaClinica(historia) {
                console.log('currentUser:', this.currentUser);
                console.log('pacienteSeleccionado:', this.pacienteSeleccionado);
                console.log('displayName:', this.currentUser?.displayName || 'No especificado');
                const payload = {
                    ...historia,
                    displayName: this.currentUser?.displayName || 'No especificado',
                    datosPaciente: this.pacienteSeleccionado
                };
                console.log('Imprimiendo historia de historia:', payload);
                this.openLoading();
                    try {
                        const response = await axios.post(`${API}/imprimir-historia-clinica`, payload);
                        if (response.data.status === 'success') {
                            this.closeLoading();
                            console.log('Receta médica generada:', response.data);
                            const pdfUrl = `${API}${response.data.pdfUrl}`;
                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        } else {
                            this.closeLoading();
                            this.notify('error', 'Error al generar la receta médica.');
                        }
                    } catch (error) {
                        this.closeLoading();
                        this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
         
                    } 
            },
            async toggleNotaMedica() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para ver su nota médica.');
                    return;
                }
                this.showHistoriaClinica = false; // Ocultar Historia Clínica
                this.showNotaMedica = false; // Ocultar Nota Médica
                console.log('Paciente seleccionado:', this.pacienteSeleccionado);
                try {
                    this.openLoading();
                    const response = await axios.get(`${API}/historia_consultas/${this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id}`);
                    if (response.data.status === 'success') {
                        console.log('Consultas:::::', response.data.data);
                        const now = new Date();
                        this.notaMedicaConsultas = response.data.data;
                        // this.notaMedicaConsultas = response.data.data.filter(consulta => {
                        //     const consultaDate = new Date(consulta.creado_en);
                        //     const diffHours = (now - consultaDate) / (1000 * 60 * 60);
                        //     return diffHours <= 24;
                        // });
                        this.showNotaMedica = true;
                        setTimeout(() => {
                        const el = this.$refs.nuevoDiv;
                        if (el && el.scrollIntoView) {
                            el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                            });
                        } else {
                            console.warn('No se encontró el ref nuevoDiv');
                        }
                        }, 333);
                        // if (this.showNotaMedica) {
                        //     this.showHistoriaClinica = false; // Ocultar Historia Clínica
                        // }
                    } else {
                        this.notify('error', 'Error al obtener las consultas para la nota médica.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
            
            async toggleNotaMedicaHistorico() {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para ver su nota médica.');
                    return;
                }
                this.showNotaMedica = false; // Ocultar Nota Médica
                try {
                    this.openLoading();
                    const response = await axios.get(`${API}/historia_consultas_notas/${this.pacienteSeleccionado.paciente_id || this.pacienteSeleccionado.id}`);
                    if (response.data.status === 'success') {
                        const now = new Date();
                        this.notaMedicaConsultas = response.data.data
                        // this.notaMedicaConsultas = response.data.data.filter(consulta => {
                            //     const consultaDate = new Date(consulta.creado_en);
                            //     const diffHours = (now - consultaDate) / (1000 * 60 * 60);
                            //     return diffHours <= 24;
                            // });
                            this.showNotaMedica = true;
                            setTimeout(() => {
                            console.log('Consultas------:', response.data.data);
                        const el = this.$refs.nuevoDiv;
                        if (el && el.scrollIntoView) {
                            el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                            });
                        } else {
                            console.warn('No se encontró el ref nuevoDiv');
                        }
                        }, 333);
                        // if (this.showNotaMedica) {
                        //     this.showHistoriaClinica = false; // Ocultar Historia Clínica
                        // }
                    } else {
                        this.notify('error', 'Error al obtener las consultas para la nota médica.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                } finally {
                    this.closeLoading();
                }
            },
           


            openNotaMedica(nota) {
                console.log('Nota médica seleccionada:', nota);
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para generar una nota médica.');
                    return;
                }
                this.consultaSeleccionada = nota;
                this.showNotaMedicaDialog = true;
            },
            verNotaMedicaMet(id) {
                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Debe seleccionar un paciente para generar una nota médica.');
                    return;
                }
                this.showHistoriaConsultasDialog = false;
                this.nota_medica_id = id;
                setTimeout(() => {
                    this.showNotaVerMedicaDialog = true;
                }, 333);
            },
            closeNotaMedica() {
                this.showNotaMedicaDialog = false;
                this.fetchPacientes();
                this.toggleNotaMedica();
            },
            formatDateTime(dateString) {
                if (!dateString) return 'No aplica';
                const date = new Date(dateString);
                const dd = String(date.getDate()).padStart(2, '0');
                const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const yyyy = date.getFullYear();
                const hh = String(date.getHours()).padStart(2, '0');
                const min = String(date.getMinutes()).padStart(2, '0');
                const ss = String(date.getSeconds()).padStart(2, '0');
                return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
            }
        },
    };
</script>

<style>
    .img-preview {
        max-width: 50%;
        height: auto;
        margin-top: 10px;
    }

    .img-container {
        max-width: 50%;
        height: auto;
        margin-top: 10px;
        position: relative;
    }

    .img-container img {
        display: block;
        max-width: 66%;
    }

    .responsive-img-container {
        width: 50%;
        height: auto;
        overflow: hidden;
        position: relative;
    }

    .circular-image {
        border-radius: 50%;
    }

    .autocomplete-results {
        border: 1px solid #ccc;
        max-height: 200px;
        overflow-y: auto;
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .autocomplete-results li {
        padding: 8px;
        cursor: pointer;
    }

    .autocomplete-results li:hover {
        background-color: #f0f0f0;
    }

    .full-width-dialog .vs-dialog {
        width: 60%;
        max-width: none;
    }

    .full-width-dialog .vs-dialog .vs-dialog-content {
        padding: 20px;
    }

    .full-width-dialog .vs-dialog .vs-dialog-header,
    .full-width-dialog .vs-dialog .vs-dialog-footer {
        padding: 10px 20px;
    }

    /* Estilos para ajustar el ancho de las columnas */
    .custom-table .col-nombre {
        width: 30%;
        /* 30% del ancho total */
    }

    .custom-table .col-genero {
        width: 15%;
        /* 15% del ancho total */
    }

    .custom-table .col-fecha {
        width: 15%;
        /* 15% del ancho total */
    }

    .custom-table .col-creacion {
        width: 20%;
        /* 20% del ancho total */
    }

    .custom-table .col-acciones {
        width: 20%;
        /* 20% del ancho total */
    }

    .vs-dialog-content {
        z-index: 1050 !important;
    }
</style>